// src/providers/AuthProvider.tsx
import { useEffect } from "react";
import { useAuthStore } from "@/store/auth.store";
import { firebaseAuth } from "@/lib/firebase-config";
import { Loader } from "lucide-react";
import { AuthStatus } from "@/common/enums/enums";

export const AuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const { reSignIn, authStatus } = useAuthStore();

  useEffect(() => {
    const unsub = firebaseAuth.onAuthStateChanged((user) => {
      void reSignIn(user);
    });
    return (): void => {
      unsub();
    };
  }, [reSignIn]);

  if (authStatus === AuthStatus.LOADING) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader aria-label="loading" className="animate-spin" role="img" />
      </div>
    );
  }

  return <>{children}</>;
};
